import { Link, NavLink } from "react-router-dom";
import { useAccountGate } from "../../js/hooks/useAccountGate";

export function GatedLink({ to, className, children, allow = false, onClick, ...rest }) {
  const { allowed, gateEvent } = useAccountGate();
  const open = allow || allowed;

  return (
    <Link
      to={open ? to : "/start"}
      className={className}
      onClick={(event) => {
        if (!open && gateEvent(event, to)) return;
        onClick?.(event);
      }}
      {...rest}
    >
      {children}
    </Link>
  );
}

export function GatedNavLink({ to, className, children, allow = false, end, onClick }) {
  const { allowed, gateEvent } = useAccountGate();
  const open = allow || allowed;

  return (
    <NavLink
      to={open ? to : "/start"}
      end={end}
      className={className}
      onClick={(event) => {
        if (!open && gateEvent(event, to)) return;
        onClick?.(event);
      }}
    >
      {children}
    </NavLink>
  );
}
